// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"9b09a590","513":"78c5898c","703":"a81836f3"}[chunkId] + ".chunk.js";
};